import { useCallback, useEffect, useMemo, useState } from 'react'
import { IntlShape } from 'react-intl'

import { EquipmentRowDraft, buildEquipmentRowKey } from 'pages/costs/common/equipmentSelectHelpers'
import {
	clearDraft,
	ensureDraft,
	getDraftSnapshot,
	subscribeToDraft,
	updateDraft,
} from 'pages/costs/EquipmentAndConstruction/equipmentRowStore'

const EMPTY_DRAFT: EquipmentRowDraft = {}

export const useEquipmentRowDraft = (rowData: any, intl: IntlShape) => {
	const rowKey = useMemo(
		() => buildEquipmentRowKey(rowData),
		[rowData?.id, rowData?.countryName, rowData?.networkAreaName]
	)
	const [draft, setDraftState] = useState<EquipmentRowDraft>(() => getDraftSnapshot(rowKey) ?? EMPTY_DRAFT)

	useEffect(() => {
		ensureDraft(rowKey, rowData, intl)
		setDraftState(getDraftSnapshot(rowKey) ?? EMPTY_DRAFT)

		const unsubscribe = subscribeToDraft(rowKey, () => {
			setDraftState(getDraftSnapshot(rowKey) ?? EMPTY_DRAFT)
		})

		return () => {
			unsubscribe()
		}
	}, [rowKey, rowData, intl])

	const setDraft = useCallback(
		(patch: Partial<EquipmentRowDraft>) => {
			updateDraft(rowKey, patch)
		},
		[rowKey]
	)

	const resetDraft = useCallback(() => {
		clearDraft(rowKey)
	}, [rowKey])

	return { rowKey, draft, setDraft, resetDraft }
}
